import React from "react";
import HttpServices from "../../utils/Http.services";
import { checkTranslation, getObject } from "../../utils/useful";
// import { domain, headers, colors, settings } from '../../Variables'

import NumberInput from "./NumberInput";


class AttributesLoader extends React.Component {
    state = {
        options: [],
        isLoading: false,
        value: {}
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({ value: this.props.data })
        }
        this.mounted = true
        this.init()
    }

    componentWillUnmount() {
        this.mounted = false
    }


    componentDidUpdate(prevProps) {

        // if (this.mounted) {
        // let hasDependency = (prevProps.header.dependencies && prevProps.header.dependencies.length > 0)
        // console.log(this.props.header.information.refValue)
        if (this.props.header.information.refValue != this.props.header.information.refValue) {
            this.init()
        }

        if (prevProps.data != this.props.data && this.mounted) {
            // console.log("SET VALUE")
            this.setState({ value: this.props.data })
        }
        // }
    }


    init() {
        // console.log("INIT")
        // console.log(this.props.header.information.type)
        if (this.props.header?.information && this.mounted) {
            if (this.props.header.information.type == "local") {
                this.setState({ options: this.props.header.information.items })
            } else if (this.props.header.information.type == "api") {
                this.setState({ options: [] }, (
                    this.fetch()
                ))
            }
        }
    }


    makeFilter() {

        let filter = this.props.header.information.filter
        // if(!filter.filter){
        //     filter.filter = {}
        // }
        let refValue = this.props.header.information.refValue
        filter[this.props.header.information.refKey] = refValue[refValue.length - 1]//this.props.header.information.refValue

        // let hasDependency = (this.props.header.dependencies && this.props.header.dependencies.length > 0)

        // let filter = {}

        // if (hasDependency) {
        //     this.props.header.dependencies.forEach(dependency => {
        //         if (dependency.type == 'filter') {
        //             // let value = this.props.getValue(dependency.field)
        //             let value = getObject(dependency.field)

        //             if (value) {
        //                 filter[dependency.param] = value[value.length - 1]
        //             }
        //         }
        //     });
        //     // console.log(filter)
        // }

        return filter
    }


    fetch() {
        // console.log("fetch")
        // console.log(this.props.header.information.refValue)
        if (this.props.header.information.refValue) {


            // console.log(this.props.header.information.address)
            // console.log(filter)


            let filter = this.makeFilter()
            console.log(filter)

            // if (filter["values.categories"] && this.mounted) {
            this.setState({ isLoading: true })
            // fetch(this.props.header.information.address, {
            //     method: 'POST',
            //     body: JSON.stringify({ filter: filter }),
            //     headers: headers
            // }).then(response => response.json()).then(data => {

            if (filter["values.categories"]) {
                HttpServices.request(this.props.header.information.address, { filter: filter }, (data, fetchError) => {
                    if (fetchError) { return }
                    if (data.status == 200 && this.mounted) {
                        var newData = []
                        // console.log(data)
                        // console.log({...this.props.data})

                        data.info.forEach(element => {

                            // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                            // var newValue = this.spliter(element, this.props.header.information.fields.value)

                            newData.push(element)
                        })


                        if (this.props.data && Array.isArray(newData)) {
                            for (const [key, value] of Object.entries(this.props.data)) {
                                let found = false
                                // console.log(key)
                                // console.log(newData)

                                for (let i = 0; i < newData.length; i++) {
                                    const element = newData[i];
                                    if (key == element._id) {
                                        found = true
                                    }

                                    // console.log(key)
                                    // console.log(element)
                                }
                                // newData.forEach(element => {
                                //     console.log(key)
                                //     console.log(element._id)

                                // });

                                // if (!found) {
                                //     this.changeValue(key, null, 'remove')
                                // }
                            }
                        }
                        if (this.mounted) {
                            this.setState({
                                options: newData,
                                isLoading: false
                            })
                        }
                    }

                })
            }
            // .catch(error => { console.log(error); this.setState({ error, isLoading: false }) });
            // }
        }
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    changeValue = (key, value, extra) => {
        let newValue = this.state.value

        if (!newValue) {
            newValue = {}
        }
        newValue[key] = value
        this.state.value = newValue

        if (extra == 'remove') {
            delete newValue[key]
        }


        console.log("changeValue")
        console.log(newValue)
        this.props.changeValue(this.props.header.key, newValue, this.props.extra)

    }


    render() {
        return (
            <div className="px-2 w-100">
                <div className="row">
                    {this.state.options.map((prop, index) => {
                        let settings = prop.settings ? prop.settings : {}
                        settings.required = true
                        if (this.props.data && this.props.data[prop._id] == null) {
                            this.changeValue(prop._id, '')
                        }
                        settings.label = prop.values.name + (prop.values.suffix ? ' (' + prop.values.suffix + ')' : '')
                        console.log(this.props.data)
                        return (
                            <div key={index} className='mb-2 col-12 col-lg-6 pt-2 ' style={{ position: 'relative' }}>

                                {prop.values && (
                                    <div className="">
                                        <div className="mb-2">
                                            <label style={{ color: '#F87C56' }} className={'text-uppercase text-smaller mr-1 ml-1  ' + (settings?.required ? 'required' : '')}>{checkTranslation(settings.label)}</label>
                                        </div>
                                        <div className="flexc modern-input">
                                            <NumberInput data={this.props.data ? checkTranslation(this.props.data[prop._id]) : null} header={{ key: prop._id, information: settings }} changeValue={this.changeValue} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })}

                </div>
            </div>
        );
    }
}

export default AttributesLoader;
